import React, { useEffect, useState } from 'react';
import { FiX, FiAlertCircle, FiCheckCircle, FiInfo } from 'react-icons/fi';
import './Alert.css';

const Alert = ({ type, message, onClose, autoClose = true }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        setVisible(false);
        onClose && onClose();
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, [autoClose, onClose]);

  if (!visible) return null;

  const getIcon = () => {
    switch (type) {
      case 'error':
        return <FiAlertCircle size={20} />;
      case 'success':
        return <FiCheckCircle size={20} />;
      case 'info':
        return <FiInfo size={20} />;
      default:
        return null;
    }
  };

  return (
    <div className={`alert alert-${type}`}>
      <div className="alert-content">
        {getIcon()}
        <span>{message}</span>
      </div>
      <button
        className="alert-close"
        onClick={() => {
          setVisible(false);
          onClose && onClose();
        }}
      >
        <FiX size={18} />
      </button>
    </div>
  );
};

export default Alert;